import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeatureCard1Block as Block } from "./FeatureCard1Block";
import { defaultData } from "./FeatureCard1BlockDefaultData";
import imagePreview from "./imagePreview.png";

export const FeatureCard1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Feature Card 1",
    nameI18n: "builder_ui.block_type.feature_card_1",
    version: 1,
    isHidden: true,
    props: {
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
